import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ItemUnitEntity } from '../../domain/entities/ItemUnitsEntity'
import type { ItemUnitAdminDto } from '@/backend/market'

export class ItemUnitModel extends ItemUnitEntity {
  constructor(dataDto:ItemUnitAdminDto) {
    super()
    mapEntityProperties<ItemUnitEntity>(this, dataDto)
  }
}
 